import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, } from "react-bootstrap";

import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Preloader from "../components/preloader/Preloader";
import Footer from "../components/footer/Footer";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import EmployeeAttendanceReportSection from '../components/EmployeeAttendanceReport/EmployeeAttendanceReportSection'
import { PageCardShimmer } from "../components/preloader/PageCardShimmer";
import { getAuthorizedBranchIds } from "../utils/authHelper";

// const FETCH_GLOBALS = gql`
//   query($institution_id: Int!) {
//     globals(institution_id: $institution_id) {
//       globalBranches {
//         id
//         branch_name
//       }
//     }
//   }
// `;

const FETCH_BRANCHES = gql`
  query($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
    }
  }
`;



class EmployeeAttendanceReport extends Component {
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    render() {

        const globals = this.props.globals;
        const loading = globals.loading;
        const error1 = globals.error;

        // const getYears = this.props.getYears;
        // const loading2 = getYears.loading;
        // const error2 = getYears.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        // if (error2 !== undefined) {
        //     alert("Server Error. " + error2.message);
        //     return null;
        // }
        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />

                </div>
                <div className="main-wrapper">
                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        <Container fluid>
                            {
                                loading == true ?
                                    (
                                        <PageCardShimmer filters={4} />
                                    )
                                    :
                                    (
                                        <>
                                            {
                                                (() => {
                                                    // Build the branch list from getBranches (was: globals.globalBranches).
                                                    let branchList = globals.getBranches || [];

                                                    if (Cookies.get("userlevel") != "1" && Cookies.get("userlevel") != "2") {
                                                        // The branch_id cookie holds the user's authorized branches as a
                                                        // comma-separated list (e.g. "10,12,15"); keep every branch the
                                                        // user has access to, not just an exact single-id match.
                                                        // let globalBranches = [];
                                                        // globalsData.globalBranches.map((item) => {
                                                        //     if (Cookies.get("branch_id") == item.id) {
                                                        //         globalBranches.push(item)
                                                        //     }
                                                        // });
                                                        // globalsData.globalBranches = globalBranches
                                                        const authorizedIds = getAuthorizedBranchIds();
                                                        if (authorizedIds.length) {
                                                            branchList = branchList.filter((item) => authorizedIds.includes(String(item.id)));
                                                        }
                                                    }

                                                    // Keep the prop shape the section expects ({ globalBranches: [...] }).
                                                    const globalsData = { globalBranches: branchList };
                                                    console.log("globalsData", globalsData);

                                                    return (
                                                        <>

                                                            <EmployeeAttendanceReportSection
                                                                globals={globalsData}

                                                            />
                                                        </>
                                                    );
                                                })()
                                            }
                                        </>
                                        // <EmployeeAttendanceReportSection
                                        //     globals={globals.globals}
                                        // />
                                    )
                            }
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default withRouter(withApollo(compose(
    graphql(FETCH_BRANCHES, {
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "globals",
    }),
)(EmployeeAttendanceReport))
);